<template>
    <CardContentPanel icon="info-circle" v-bind="{action, index}">
        <template #title>{{ $t('projectclient.projectview.activity.pending.actions.TERMS_REVIEW_REQUESTED.title') }}</template>
        <template #body>{{ $t('projectclient.projectview.activity.pending.actions.TERMS_REVIEW_REQUESTED.description') }}</template>
        <template #actions>
            <NuxtLink :to="`/project/${projectInformation.projectId}/contract-amendment`" data-testid="pending-action-card-cta-primary">
                <VJoyButton variant="main" size="small">
                    {{ $t('projectclient.projectview.activity.pending.actions.TERMS_REVIEW_REQUESTED.action.primary') }}
                </VJoyButton>
            </NuxtLink>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import {useProjectInformationStore} from '@/common/stores';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'TERMS_REVIEW_REQUESTED'>;
        index: number;
    }>();

    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);
</script>
